import  './AboutUs.css'
function About(){
    return <div>
<section class="about-section">
        <div class="container">
            <div class="row">                
                <div class="content-column col-lg-6 col-md-12 col-sm-12 order-2">
                    <div class="inner-column">
                        <div class="sec-title">
                            <span class="title">Sobre nosotros</span>
                            <h2> <br/> Joyeros desde 1872</h2>
                        </div>
                        <div class="text"> ALTA JOYERÍA es diseño, maestría y buen hacer. Los únicos joyeros españoles que realizan todo el proceso de creación de una joya, de forma completamente artesanal, en nuestros talleres.</div>
                        <ul class="list-style-one">
                            <li>Alta calidad</li>
                            <li>Estilo personalizado</li>
                            <li>Atención postventa</li>
                        </ul>
                       
                    </div>
                </div>   
            </div>
        </div>
 </section>

    </div>

}
export default About;
